<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-th-large"></i> Applications
        </div>
        <div class="card-body">
          <div class="mb-3">
            <button class="btn btn-sm btn-primary" type="button" (click)="onClickAdd()">
              <i class="fa fa-plus"></i> Add Application
            </button>
          </div>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>ID</th>
                <th>Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (application of applications; track application.id; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ application.id }}</td>
                  <td>{{ application.name }}</td>
                  <td>
                    <button class="btn btn-sm btn-primary me-1" type="button" (click)="onClickEdit(application)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                    <span class="text-muted mx-1">|</span>
                    <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(application)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<app-application-add-modal #addModal></app-application-add-modal>
<app-application-edit-modal #editModal></app-application-edit-modal>
